import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface AttendanceTrendData {
  month: string;
  totalMeetings: number;
  totalAttendance: number;
  averageAttendance: number;
}

interface AttendanceTrendChartProps {
  data: AttendanceTrendData[];
}

export function AttendanceTrendChart({ data }: AttendanceTrendChartProps) {
  if (!data || data.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center text-muted-foreground">
        <div className="text-center">
          <div className="text-4xl mb-2">📊</div>
          <p>No trend data available</p>
        </div>
      </div>
    );
  }

  const maxAttendance = Math.max(...data.map(d => d.averageAttendance));
  const minAttendance = Math.min(...data.map(d => d.averageAttendance));

  return (
    <div className="h-64 w-full">
      <div className="flex items-end justify-between h-full gap-2">
        {data.map((item, index) => {
          const height = (item.averageAttendance / maxAttendance) * 100;
          const isHighest = item.averageAttendance === maxAttendance;
          const isLowest = item.averageAttendance === minAttendance;
          
          return (
            <div key={index} className="flex flex-col items-center flex-1">
              <div className="relative w-full flex flex-col items-center">
                <div
                  className={`w-full rounded-t transition-all duration-500 ${
                    isHighest ? 'bg-green-500' : 
                    isLowest ? 'bg-red-500' : 
                    'bg-blue-500'
                  }`}
                  style={{ height: `${Math.max(height, 5)}%` }}
                />
                <div className="absolute -top-6 text-xs font-medium">
                  {item.averageAttendance}%
                </div>
              </div>
              <div className="mt-2 text-xs text-center">
                <div className="font-medium">{item.month}</div>
                <div className="text-muted-foreground">{item.totalMeetings} meetings</div>
              </div>
            </div>
          );
        })}
      </div>
      
      <div className="mt-4 flex justify-between text-xs text-muted-foreground">
        <span>Min: {minAttendance}%</span>
        <span>Max: {maxAttendance}%</span>
      </div>
    </div>
  );
}
